// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__3w5gg","title":"styles_title__H9RAU"};